
import { useState, useMemo } from "react";
import FullCalendar from "@fullcalendar/react";
import themePlugin from "@fullcalendar/react/themes/monarch"; // YOUR THEME
import dayGridPlugin from "@fullcalendar/react/daygrid";
import timeGridPlugin from '@fullcalendar/react/timegrid';
import interactionPlugin from '@fullcalendar/react/interaction';

// stylesheets
import '@fullcalendar/react/skeleton.css'; // ALWAYS NEED SKELETON
import '@fullcalendar/react/themes/monarch/theme.css'; // YOUR THEME
import '@fullcalendar/react/themes/monarch/palettes/purple.css'; // YOUR THEME'S PALETTE

import Events from './Events';

// FUNÇÃO PARA MAPEAR REGISTROS DE COMPROMISSOS PARA O FORMATO DO FULLCALENDAR
const mapearParaFullCalendar = (eventoOriginal) => {
  // Combina data e hora para o formato aceito pelo FullCalendar (ISO 8601)
  const dataInicio = `${eventoOriginal.date}T${eventoOriginal.time}`;
  const dataFim = `${eventoOriginal.end_date}T${eventoOriginal.end_time}`;

  return {
    id: String(eventoOriginal.id),
    title: eventoOriginal.title,
    start: dataInicio,
    end: dataFim,
    allDay: false,

    // Propriedades específicas do seu sistema
    extendedProps: {
      commitment_type_id: eventoOriginal.commitment_type_id,
      description: eventoOriginal.description,
      priority: eventoOriginal.priority,
      status: eventoOriginal.status,
      completed: Boolean(eventoOriginal.completed),
      reference_type: eventoOriginal.reference_type,
      reference_id: eventoOriginal.reference_id,
      created: eventoOriginal.created,
      modified: eventoOriginal.modified
    }
  };
};

const Calendar = ({ commitments = [] }) => {
  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [currentEvents, setCurrentEvents] = useState([]);

  // CORREÇÃO: Usa a função correta de mapeamento em cima do array vindo por props
  // O useMemo memoriza o resultado e só recalcula se 'commitments' mudar de verdade
  const eventsData = useMemo(() => {
    return commitments.map(mapearParaFullCalendar);
  }, [commitments]);

  const renderEventContent = (eventInfo) => {
    return (
      <>
        <b>{eventInfo.timeText}</b>
        <i>{eventInfo.event.title}</i>
      </>
    );
  };

  const handleWeekendsToggle = () => {
    setWeekendsVisible(!weekendsVisible);
  };

  const handleDateSelect = (selectInfo) => {
    let title = prompt('Please enter a new title for your event');
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect();

    if (title) {
      calendarApi.addEvent({
        id: String(Date.now()), // Gera um ID temporário único
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay
      });
    }
  };

  const handleEventClick = (clickInfo) => {
    if (window.confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
      clickInfo.event.remove();
    }
  };

  const handleEvents = (events) => {
    setCurrentEvents(events);
  };

  return (
    <div className="card h-100">
      <div className="card-header bg-transparent">
        <div className="d-flex justify-content-between align-items-center">
          <strong>Calendário</strong>
        </div>
      </div>

      <div className="card-body">
        <FullCalendar
          plugins={[themePlugin, dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView='dayGridMonth'
          locale="pt-br"

          headerToolbar={{
            left: 'prev,next today adicionar',
            center: 'title',
            right: 'dayGridMonth,timeGridWeek,timeGridDay',
          }}

          // customButtons={{
          //   adicionar: {
          //     text: '+',
          //     click: function () {
          //       alert('Ação de adicionar evento disparada!');
          //     }
          //   },
          //   today: {
          //     text: 'Hoje'
          //   }
          // }}

          buttons={{
            adicionar: {
              text: '+',
              click: function () {
                alert()
              }
            },
            today: {
              text: 'Hoje'
            },
            timeGridDay: {
              text: 'Dia'
            },
            timeGridWeek: {
              text: 'Semana'
            },
            dayGridMonth: {
              text: 'Mês'
            }
          }}

          // buttonText={{
          //   today: 'Hoje',
          //   month: 'Mês',
          //   week: 'Semana',
          //   day: 'Dia'
          // }}

          editable={true}
          selectable={true}
          selectMirror={true}
          dayMaxEvents={true}
          weekends={weekendsVisible}

          // CORREÇÃO CRÍTICA: Mudado de initialEvents para events
          events={eventsData}

          select={handleDateSelect}
          eventContent={renderEventContent}
          eventClick={handleEventClick}
          eventsSet={handleEvents}
        />
      </div>

      <Events commitments={commitments} />

      <div className="card-footer bg-transparent">
        <div className="d-flex flex-wrap gap-3 small text-muted">
          <span>🔴 Vencimento</span>
          <span>🟡 Pagamento</span>
          <span>🟢 Recebimento</span>
          <span>🔵 Outro</span>
        </div>
      </div>
    </div>
  );
};

export default Calendar;